/**
 * Site-wide JavaScript entry point.
 *
 * Bundled by esbuild into Resources/Public/JavaScript/Dist/app.min.js and
 * loaded in the page footer on every page (see page.includeJS.typoscript).
 *
 * Only the libraries actually used by the site are imported here so esbuild can
 * tree-shake everything else out of the bundle.
 */

// Bootstrap — register only the components the site uses. Importing a component
// wires up its declarative data-API (data-bs-toggle="…") automatically.
// Collapse and Tooltip are additionally imported (as classes) in main.js where
// they are instantiated from JavaScript.
import 'bootstrap/js/dist/button'
import 'bootstrap/js/dist/collapse'
import 'bootstrap/js/dist/dropdown'
import 'bootstrap/js/dist/modal'
import 'bootstrap/js/dist/offcanvas'
import 'bootstrap/js/dist/tab'
import 'bootstrap/js/dist/tooltip'
import 'bootstrap/js/dist/popover'
import 'bootstrap/js/dist/scrollspy'

// Site behaviour
import './main.js'
